import getApi from '../../api'
import { PaginatedList } from '../../model/Pagination'
import { TagType } from '../../model/Tag'
import { FwResourceType } from '../../model/Resource'

export const DEFAULT_TAGS_LIMIT_PER_PAGE = 100

export const getUsedTags = (
  page: number,
  usedInResource: FwResourceType,
  signal?: AbortSignal,
  limit = DEFAULT_TAGS_LIMIT_PER_PAGE,
) =>
  getApi().get<PaginatedList<TagType>>(
    '/tags',
    {
      page,
      limit,
      usedInResource,
    },
    { signal },
  )
